<!--Получает дерево, после обрабатывает его и получает unfoldingTree, который в следствии
становиться списком, по нажатию на элемент вызывает автобусом таблицу-->
<template>
  <v-autocomplete
    v-model="searched"
    :items="listTable.map(item => item.name)"
    persistent-hint
    label="Поиск таблиц"
    prepend-icon="mdi-file-excel"
    hide-details
    @input="getTable">

    <template slot="no-data">
      Такой таблицы не существует
    </template>
  </v-autocomplete>
</template>

<script>
import {bus} from "@/main";
import axios from "axios";

export default {
  name: "search-table",
  components: {
  },
  props: {
    regionId: Number,
    activeYear: Number,
    searchedProp: String,
    tree: [],
  },
  data() {
    return {
      unfoldingTree: [],
      searched: "",
    };
  },
  computed: {
    listTable() {
      return this.unfolding(this.tree);
    }
  },
  methods: {
    getIdTable(name) {
      return this.listTable.filter(item => item.name === name)[0].idHeader;
    },
    getSelectedTableCode(name) {
      return this.listTable.filter(item => item.name === name)[0].permissionCode;
    },
    recurse(obj) {
      if (obj.idHeader !== null) {
        this.unfoldingTree.push({name: obj.name, idHeader: obj.idHeader, permissionCode: obj.permissionCode})
      } else if (obj.children !== null) {
        for (let i = 0; i < obj.children.length; i++) {
          this.recurse(obj.children[i])
        }
      }
    },
    unfolding(obj) {
      let tree = Array.from(obj);
      tree.forEach(item => {
        this.recurse(item)
      });
      return this.unfoldingTree
    },

    getTable() {
      let code = this.getSelectedTableCode(this.searched)
      axios
        .post("/eco-passport/check-permission", {tablePermission: code})
        .then(() => {
          let headerId = this.getIdTable(this.searched);
          let info = {
            headerID: headerId,
            regionId: this.regionId,
            tableName: this.searched,
            selectedYear: this.activeYear
          };
          bus.$emit('selectedTable', info)
          bus.$emit('searchedTable', this.searched)
        })
        .catch(() => {
          this.searched = ""
          let errorMessage = {
            message: "Для доступа к этой таблице, вы должны быть авторизованными на сайте,\n а также запросить соответствующие права в министерстве экологии Красноярского края",
            show: true,
            color: "orange",
            centered: true,
            textColor: "#000",
            timeout: 8000
          }
          bus.$emit('message', errorMessage)
        })
    },
  },
  created() {
    setTimeout(()=> {
      if (this.searchedProp !== "") {
        this.searched = this.searchedProp
        this.getTable()
      }
    }, 500)
  }
}
</script>

<style scoped>

</style>